exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".butagree[data-v-240b2cc6]{background:#ff7802;border:1px solid #ff7802}.cookies[data-v-240b2cc6] .el-dialog--tiny{width:370px!important}p[data-v-240b2cc6]{color:#333;font-size:16px}a[data-v-240b2cc6]{text-decoration:none;color:#ff7802}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-240b2cc6","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/cookies.vue
// module id = n6An
// module chunks = 25 26 28 29 30 31 32 33 34 35 36 37 38 39 40